export const stateTree = {
  todoist: {
    status_ok: false,
  },
  loading: false,
  todayList: [],
};



// WEBPACK FOOTER //
// ./app/store/state.js